module.exports = __webpack_public_path__ + "img/secondary_4x4_z16.49dcea90.svg";